import React, { useEffect, useState } from 'react';

import { useParams } from 'react-router-dom';

import Modal from '../Shared/Modal';
import { Alert } from '../Shared/Alert';
import { CDN_URL } from '../../services/config';
import LoadingWheel from '../Shared/LoadingWheel';
import useAllMediaAdmin from '../../data/useAllMediaAdmin';
import { useAgency } from '../../data/agency/useAgency';

interface SocialPostPreviewModalProps {
  event: any;
  isOpen: boolean;
  onClose: () => void;
}

export default function SocialPostPreviewModal({ event, isOpen, onClose }: SocialPostPreviewModalProps) {
  const { agencyId } = useParams();
  const { agency } = useAgency(agencyId!);
  const { media } = useAllMediaAdmin(agencyId!);
  const [videoType, setVideoType] = useState<string | null>(null);
  const [mediaPreviewUrl, setMediaPreviewUrl] = useState<string | null>(null);

  const getMediaPreview = async (mediaManagerIdValue: string, classes: string) => {
    const m = media.data.find((m: any) => m.id === mediaManagerIdValue);

    if (m != null) {
      if (m.type.includes("video")) {
        setVideoType(m.type);
        setMediaPreviewUrl(`${CDN_URL}${m.path}`);
      } else {
        setMediaPreviewUrl(`${CDN_URL}${m.path}`);
      }
    } else {
      setMediaPreviewUrl(event.extendedProps.postData.ogImageUrl);
    }
  };

  useEffect(() => {
    if (!media.isLoading && event && event.extendedProps) {
      getMediaPreview(event.extendedProps.postData.mediaManagerId, "w-full object-contain my-4");
    }
  }, [media.isLoading, event]);

  if (!isOpen || !event) return null;

  return (
    <Modal open={isOpen} setOpen={onClose} width="max-w-3xl">
      {agency.isLoading ? <div className='py-10 flex items-center justify-center'><LoadingWheel width="w-8" height="h-8" /></div> :
        <div>
          <div className='flex items-center justify-start'>
            <div className='w-1/12'>
              <div className='w-14 h-14 rounded-full bg-gray-200' />
            </div>
            <div className='ml-2 w-11/12'>
              <p className='font-medium'>{agency.data?.data.name}</p>
              <p className='text-gray-600 text-sm'>now</p>
            </div>
          </div>
          <div className='my-2'>
            {event.extendedProps.postData.message}
          </div>
          {media.isLoading ? (
            <LoadingWheel width="w-8" height="h-8" />
          ) : mediaPreviewUrl !== null ? videoType !== null ?
            (
              <video
                className="w-full object-contain"
                controls
              >
                <source src={mediaPreviewUrl!} type={videoType!} />
              </video>
            ) :
            (
              <img
                src={mediaPreviewUrl!}
                alt="Media Preview"
                className="w-full object-contain my-4"
              />
            ) : (
            <Alert
              classes="my-4"
              type="error"
              title="Error"
              message="Error getting media for this post preview."
            />
          )}
        </div>
      }
    </Modal>
  );
}